import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Supported languages with metadata
export const languages = [
  { code: 'en', name: 'English', dir: 'ltr', flag: '🇺🇸' },
  { code: 'tr', name: 'Türkçe', dir: 'ltr', flag: '🇹🇷' },
  { code: 'es', name: 'Español', dir: 'ltr', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', dir: 'ltr', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', dir: 'ltr', flag: '🇩🇪' },
  { code: 'ru', name: 'Русский', dir: 'ltr', flag: '🇷🇺' },
  { code: 'ar', name: 'العربية', dir: 'rtl', flag: '🇸🇦' },
  { code: 'zh', name: '中文', dir: 'ltr', flag: '🇨🇳' },
  { code: 'zh-cn', name: '简体中文', dir: 'ltr', flag: '🇨🇳' },
  { code: 'pt', name: 'Português', dir: 'ltr', flag: '🇵🇹' },
  { code: 'hi', name: 'हिन्दी', dir: 'ltr', flag: '🇮🇳' },
  { code: 'bn', name: 'বাংলা', dir: 'ltr', flag: '🇧🇩' },
] as const;

export type LanguageCode = typeof languages[number]['code'];

export const defaultLanguage = 'en';

// i18n configuration
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLanguage,
    supportedLngs: languages.map(l => l.code),
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?v=1.0.1',
    },
    
    detection: {
      order: ['path', 'navigator', 'htmlTag', 'localStorage', 'cookie'],
      lookupFromPathIndex: 0,
      caches: ['localStorage', 'cookie'],
    },
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    react: {
      useSuspense: true,
    },
    
    // SEO-friendly key handling
    ns: ['common', 'home', 'products', 'blog', 'seo'],
    defaultNS: 'common',
    
    // Debug mode in development
    debug: import.meta.env.DEV,
  });

// Helper to get language by code
export const getLanguageByCode = (code: string) => {
  return languages.find(lang => lang.code === code) || languages[0];
};

// Helper to generate alternate URLs for SEO
export const generateAlternateUrls = (path: string) => {
  return languages.map(lang => ({
    lang: lang.code,
    url: `https://muttinyhouse.com/${lang.code}${path}`,
    dir: lang.dir,
  }));
};

// Helper for RTL detection
export const isRTL = (langCode: string) => {
  const lang = getLanguageByCode(langCode);
  return lang.dir === 'rtl';
};

export default i18n;
